import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "t3 text-context-4" }
const _hoisted_2 = { class: "flex min-h-10 items-center justify-between" }
const _hoisted_3 = { class: "flex items-baseline gap-1" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "flex"
}

import { Contact, Context } from '@/components/drawers/MemberDrawer/types/member-drawer.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentPatientContacts',
  props: {
    contacts: {}
  },
  emits: ["start-call", "copy-to-clipboard"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_sword_icon = _resolveComponent("sword-icon")!
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contacts, (contact) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `${_ctx.$t(contact.label)}-contact`,
        class: "mb-2"
      }, [
        _createElementVNode("h6", _hoisted_1, _toDisplayString(_ctx.$t(contact.label)), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(contact.content || "-"), 1),
            (!!contact.content && !!contact.warningMessage)
              ? _withDirectives((_openBlock(), _createBlock(_component_sword_icon, {
                  key: 0,
                  name: "warning"
                }, null, 512)), [
                  [_directive_tooltip, { content: contact.warningMessage, align: 'center' }]
                ])
              : _createCommentVNode("", true)
          ]),
          (!!contact.content)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (contact.showCallButton)
                  ? _withDirectives((_openBlock(), _createBlock(_component_sword_button_wuk, {
                      key: 0,
                      icon: "phone",
                      theme: "transparent",
                      round: "",
                      "aria-label": _ctx.$t('SIDEBAR.PHONE.START_CALL'),
                      onClickNative: ($event: any) => (emit('start-call', contact.content))
                    }, null, 8, ["aria-label", "onClickNative"])), [
                      [_directive_tooltip, _ctx.$t('SIDEBAR.PHONE.START_CALL')]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_sword_button_wuk, {
                  icon: "copy",
                  theme: "transparent",
                  round: "",
                  "aria-label": `click to copy ${_ctx.$t(contact.label)} to clipboard.`,
                  onClickNative: ($event: any) => (emit('copy-to-clipboard', {context: 'contact', content: contact.content}))
                }, null, 8, ["aria-label", "onClickNative"]), [
                  [_directive_tooltip, _ctx.$t('COPY.CLIPBOARD')]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})